import * as React from 'react';
import AuthContext, { AuthContextApi } from './context';
import axios from '../../services/request';
import { User } from '../../Types/User';

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [isAuthenticated, setIsAuthenticated] = React.useState(
    !!sessionStorage.getItem('token')
  );

  const [user, setUser] = React.useState<User | undefined>();
  const [isPartner, setIsPartner] = React.useState<boolean>(false);
  const [isExpert, setIsExpert] = React.useState<boolean>(false);

  const setToken = (token: string) => {
    sessionStorage.setItem('token', token);
    setIsAuthenticated(true);
  };

  const logout = () => {
    sessionStorage.removeItem('token');
    setIsAuthenticated(false);
  };

  const getUser = async (): Promise<User | undefined> => {
    try {
      const res = await axios.get(`/users/me/`);
      const u = res.data as User;
      setIsExpert(u.is_expert);
      setIsPartner(u.is_partner);
      setUser(u);
      return u;
    } catch (error) {
      return undefined;
    }
  };

  const getProfile = async (
    userId: string | number
  ): Promise<User | undefined> => {
    try {
      const res = await axios.get(`/users/${userId}/profile/`);
      const u = res.data as User;
      return u;
    } catch (error) {
      return undefined;
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        getUser,
        setToken,
        logout,
        user,
        isPartner,
        isExpert,
        getProfile,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextApi => React.useContext(AuthContext);
